import * as Types from '../../../__generated__/schema';

import { AlertDetailsFull } from './AlertDetailsFull.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type AlertSummaryFull = {
  origin:
    | Pick<Types.AlertOriginPolicy, 'policyId' | 'resourceTypes' | 'resourceId' | 'policySourceId'>
    | Pick<
        Types.AlertOriginReplayedRule,
        'ruleId' | 'logTypes' | 'replayId' | 'dedupString' | 'eventsMatched' | 'scheduledQueries'
      >
    | Pick<Types.AlertOriginRule, 'ruleId' | 'logTypes' | 'scheduledQueries' | 'eventsMatched'>
    | Pick<Types.AlertOriginSystemError, 'relatedComponent'>
    | Pick<Types.Detection, 'id'>
    | Pick<Types.SystemError, 'relatedComponent'>;
} & AlertDetailsFull;

export const AlertSummaryFull = gql`
  fragment AlertSummaryFull on Alert {
    ...AlertDetailsFull
    origin {
      ... on AlertOriginPolicy {
        policyId
        resourceTypes
        resourceId
        policySourceId
      }
      ... on AlertOriginRule {
        ruleId
        logTypes
        scheduledQueries
        eventsMatched
      }
      ... on AlertOriginSystemError {
        relatedComponent
      }
      ... on AlertOriginReplayedRule {
        ruleId
        logTypes
        replayId
        dedupString
        eventsMatched
        scheduledQueries
      }
      ... on Detection {
        id
      }
      ... on SystemError {
        relatedComponent
      }
    }
  }
  ${AlertDetailsFull}
`;
